import { render, staticRenderFns } from "./ConfirmationCheckbox.vue?vue&type=template&id=142ad71a&"
import script from "./ConfirmationCheckbox.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports